import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.FLIGHT_REFUNDS,
    name: "FlightRefunds",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_REFUNDS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_REFUNDS.PERMISSIONS,
    },
    component: () => import("@/modules/FlightRefunds/views/FlightRefunds.vue"),
  },
];

export default routes;
